import { Dispatch } from "react";
import { setInitialScanQr, setUserInfoBd, setUserInfoTg } from "./store/user";
import { API } from "./API";
import { getUserItems } from "./store/collectedItems";
import { NavigateFunction } from "react-router-dom";
import { setDeeplinkStoryId } from "./store/stories";
import { isValidInviteCode } from "../UI/consts/telegram";

const PROFILE_LOAD_RETRY_DELAYS_MS = [300, 700, 1500];

async function fetchUserWithRetry(telegramId: number | string) {
    let userInfo = await API.user.get(telegramId);
    if (userInfo) return userInfo;
    for (const delay of PROFILE_LOAD_RETRY_DELAYS_MS) {
        await new Promise((r) => setTimeout(r, delay));
        userInfo = await API.user.get(telegramId);
        if (userInfo) return userInfo;
    }
    return null;
}

function showProfileLoadFailure() {
    try {
        window.Telegram.WebApp.HapticFeedback.notificationOccurred('error');
        window.Telegram.WebApp.showAlert(
            'Не удалось загрузить профиль. Проверьте интернет и перезапустите приложение.'
        );
    } catch {
        console.warn('Профиль не загружен, нет связи с сервером');
    }
}

    export async function initialFetch(
      setIsLoading: Dispatch<React.SetStateAction<boolean>>,
      setWelcomeOpen: Dispatch<React.SetStateAction<boolean>>,
      params: URLSearchParams,
      navigate: NavigateFunction
    ) {
      const user = window.Telegram.WebApp.initDataUnsafe.user;
      if (!user?.id) {
        showProfileLoadFailure();
        setIsLoading(false);
        return;
      }

      const telegramId = user.id;
      const chat_id = params.get("chat_id") || String(telegramId);
      const startParam = window.Telegram.WebApp.initDataUnsafe.start_param || '';
      const rawInvited = startParam.startsWith("ref") ? startParam.substring(3).trim().toLowerCase() : '';
      // invite_code в бэке хранится полным UUID. Отсекаем "undefined"/"null"/пустое,
      // чтобы не создавать юзера с мусорным invited_by.
      const invitedId: string | null = isValidInviteCode(rawInvited) ? rawInvited : null;
      const notOnlyTask = !startParam.includes('task') || startParam.replace('task', '').trim() !== '';

      let achievementId = null;
      if (startParam.includes('achv')) {
        achievementId = startParam.replace('achv', '').trim();
      }

      const isStoryDeeplink = startParam.startsWith('story');
      const storyId = isStoryDeeplink ? startParam.substring(5) : null;

      setUserInfoTg(user);

      if (startParam.includes('task')) {
        navigate('/MissionsPage');
      }

      let userInfo = await API.user.get(telegramId);
      if (!userInfo) {
        const newUser = await API.user.create({
          chat_id,
          cookie: null,
          ip: null,
          name: user?.first_name,
          user_agent: null,
          username: user?.username,
          telegram_id: telegramId.toString(),
          invited_by: invitedId
        });

        if (!newUser) {
          // POST /users мог упасть на rate limit/auth/timeout, но при этом юзер
          // мог быть создан в БД (commit идёт до bot.send_message). Делаем fallback GET
          // с ретраем, чтобы не оставить $userInfoBd=null.
          userInfo = await fetchUserWithRetry(telegramId);
          if (!userInfo) {
            showProfileLoadFailure();
            setIsLoading(false);
            return;
          }
          setUserInfoBd(userInfo);
        } else {
          userInfo = await fetchUserWithRetry(telegramId);
          if (userInfo) {
            setUserInfoBd(userInfo);
            setWelcomeOpen(true);
          } else {
            showProfileLoadFailure();
            setIsLoading(false);
            return;
          }
        }
      } else {
        setUserInfoBd(userInfo);
      }

      const scanQr = window.Telegram.WebApp.initDataUnsafe.start_param;
      setTimeout(() => setIsLoading(false), 1000);

      if (storyId) {
        setDeeplinkStoryId(storyId);
        await getUserItems();
      } else if (scanQr && !invitedId && notOnlyTask) {
        const identifier:string = scanQr.replace('task', '').trim();
        setInitialScanQr(achievementId ? {type:'ach',value:achievementId} :{type:'toy',value:identifier})
      } else {
        await getUserItems();
      }
    }
